import { render, staticRenderFns } from "./visits_hk.vue?vue&type=template&id=7b1220f8&"
import script from "./visits_hk.vue?vue&type=script&lang=js&"
export * from "./visits_hk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports